export interface CostTimeseries {
  id: string;
  scenarioId: string,
  type: CostTypesEnum;
  dynamic: boolean;
  data: CostTimeseriesChart[];
}

export interface CostTimeseriesChart {
  timestamp: number;
  value: number;
}

export interface CostTimeseriesResponse {
  data: CostTimeseries[];
}

export enum CostTypesEnum {
  BEFORE_TARIFF = 'BEFORE_TARIFF',
  AFTER_TARIFF = 'AFTER_TARIFF',
  AFTER_PV = 'AFTER_PV',
  AFTER_ESS = 'AFTER_ESS',
}